<template>
    <q-page padding>
        <q-tabs color="white" text-color="primary" underline-color="primary" class="shadow-1 bg-white" align="justify">
            <q-tab default slot="title" name="podcasts" :label="$t(title_podcasts)" icon="fal fa-podcast" />

            <q-tab-pane name="podcasts" class="q-px-md q-pb-xl q-mt-md">
                <div class="row gutter-sm">
                    <div :class="filterClass">
                        <filter-podcasts @changeFilter="changeFilter" />
                    </div>

                    <div :class="contentClass" style="min-height: 700px;">

                        <q-tabs v-model="tab" align="justify" class="shadow-1">

                            <q-tab slot="title" name="podcast"  icon="fal fa-podcast"  :label="$t(title_podcasts)"/>
                            <q-tab slot="title" name="playlist" icon="fal fa-user-music"  :label="$t('playlist')" />

                            <q-tab-pane name="podcast" class="q-px-lg q-pb-xl" keep-alive>
                                <div class="row gutter-md">
                                    <div class="col-12">
                                        <div class="row gutter-md">
                                            <div class="col-xs-12 col-sm-12" v-for="(podcast, index) in podcasts" :key="index">
                                                <card-desktop :podcast="podcast" v-if="$q.platform.is.desktop" :key="podcast.id" @clickLike="clickLike" @clickStars="clickStars" @clickFavorite="clickFavorite" @playPlaylist="playPlaylist" @playAudio="playAudio" />

                                                <card-mobile :podcast="podcast" v-if="$q.platform.is.mobile" :key="podcast.id" @clickLike="clickLike" @clickStars="clickStars" @clickFavorite="clickFavorite" @playPlaylist="playPlaylist" @playAudio="playAudio" />
                                            </div>

                                            <div class="col-xs-12 col-sm-12" v-if="podcasts.length === 0">
                                                <q-card>
                                                    <q-card-title>
                                                        {{ $t('no_podcasts_found') }}
                                                    </q-card-title>
                                                    <q-card-separator />
                                                    <q-card-main v-if="this.search || this.selected_areas.length > 0 || this.favorite != 'all' || this.progress != 'all'">
                                                        {{ $t('searched_term_returned_no_results') }}
                                                    </q-card-main>
                                                    <q-card-main v-else>
                                                        {{ $t('there_are_no_podcasts_avaliable_at_the_moment') }}
                                                    </q-card-main>
                                                </q-card>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </q-tab-pane>

                            <q-tab-pane name="playlist" class="q-px-lg q-pb-xl" keep-alive>
                                <div class="row gutter-md">
                                    <div class="col-12">
                                        <div class="row gutter-md">
                                            <div class="col-xs-12 col-sm-12" v-for="(podcast, index) in user_podcasts" :key="index">
                                                <card-desktop :podcast="podcast" v-if="$q.platform.is.desktop" :key="podcast.id" @clickLike="clickLike" @clickStars="clickStars" @clickFavorite="clickFavorite" @playPlaylist="playPlaylist" @playAudio="playAudio" @fetchUserPodcast="fetchUserPodcast" />

                                                <card-mobile :podcast="podcast" v-if="$q.platform.is.mobile" :key="podcast.id" @clickLike="clickLike" @clickStars="clickStars" @clickFavorite="clickFavorite" @playPlaylist="playPlaylist" @playAudio="playAudio" @fetchUserPodcast="fetchUserPodcast"/>
                                            </div>

                                            <div class="col-xs-12 col-sm-12" v-if="user_podcasts.length === 0">
                                                <q-card>
                                                    <q-card-title>
                                                        {{ $t('no_podcasts_found') }}
                                                    </q-card-title>
                                                    <q-card-separator />
                                                    <q-card-main v-if="this.search || this.selected_areas.length > 0 || this.favorite != 'all' || this.progress != 'all'">
                                                        {{ $t('no_podcasts_found_with_this_filter') }}
                                                    </q-card-main>
                                                    <q-card-main v-else>
                                                        {{ $t('there_are_no_podcasts_avaliable_at_the_moment') }}
                                                    </q-card-main>
                                                </q-card>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </q-tab-pane>
                        </q-tabs>
                    </div>
                </div>
            </q-tab-pane>
        </q-tabs>

        <q-page-sticky v-if="playlist.length > 0" position="bottom-right" :offset="[16, 16]">
            <q-btn fab="" color="primary" icon="fas fa-plus" class="animate-pop" @click="clickPlaylist()" />
        </q-page-sticky>

        <modal-stars  :show="show_modal" :podcast="podcast" @hideModal="hideModal" />

        <addPodcastinPlaylist :show="show_modal_playlist"  @hideModalListPlaylist="hideModalListPlaylist"/>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { debounce } from 'quasar'
import Filter from 'components/podcasts/Filter'
import CardDesktop from 'components/podcasts/CardDesktop'
import CardMobile from 'components/podcasts/CardMobile'
import ModalStars from 'components/podcasts/ModalStars'
import addPodcastinPlaylist from 'components/podcasts/addPodcastinPlaylist'


export default {
    i18nOptions: { namespaces: [ 'custom', 'common', 'podcasts'] },

    data() {
        return {
            podcasts: [],
            podcast: {},
            show_modal: false,
            stop_podcast: {},
            stop_audio: {},
            tab: 'podcast',
            show_modal_playlist: false,
            user_podcasts: []
        }
    },

    components: {
        'filter-podcasts': Filter,
        'card-desktop': CardDesktop,
        'card-mobile': CardMobile,
        'modal-stars': ModalStars,
        'addPodcastinPlaylist': addPodcastinPlaylist
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            reload_content: 'common/reload_content',
            clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected',
            search: 'podcasts/search',
            progress: 'podcasts/progress',
            favorite: 'podcasts/favorite',
            selected_areas: 'podcasts/selected_areas',
            selected_groups: 'podcasts/selected_groups',
            status: 'podcasts/status',
            playlist: 'podcasts/playlist',
            progress_audio: 'podcasts/progress_audio',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        filterClass() {
            if (this.$q.platform.is.ipad) return 'col-12'
            else return 'col-xs-12 col-sm-3'
        },

        contentClass() {
            if (this.$q.platform.is.ipad) return 'col-12'
            else return 'col-xs-12 col-sm-9'
        },

        title_podcasts(){
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
				if (obj) {
					return obj.title_podcasts == '' ? 'podcasts' : obj.title_podcasts
				}
			}
        },
    },

    methods: {
        fetchPodcasts() {
            this.$q.loading.show()

            let data = {
                "page_size": 0,
                "page": this.page,
                "search": this.search,
                "favorited": this.favorite === 'all' ? false : true,
                "areas": this.selected_areas,
                "user_groups": this.selected_groups
            }
            if (this.progress !== 'all') data.progress = this.progress
            this.$axios.get(`/etraining_podcast/podcasts/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.podcasts = response.data.map(e => {
                    return {
                        ...e,
                        image_thumb: e.podcast_playlist_images.length > 0 ? e.podcast_playlist_images.find((obj) => { return obj.name === 'thumbnail' }).image_url : '',
                        image_large: e.podcast_playlist_images.length > 0 ? e.podcast_playlist_images.find((obj) => { return obj.name === 'large' }).image_url : '',
                        type: 'podcast',
                    }
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        fetchLists() {
            this.$axios.get(`/accounts/get_site_registration_lists/`, this.getHeader)
            .then(response => {
                this.$store.dispatch('site_lists/SET_LISTS', [response.data])
            })
            .catch(e => {
                console.log(e)
            })
        },

        playPlaylist(podcast) {
            let audios = []
            let found = false

            let list = podcast.type == "user_podcast" ? this.user_podcasts : this.podcasts

            if (this.status === 'stopped') {
                list.forEach(p => {
                    if (p.id === podcast.id) {
                        found = true

                        p.podcast_playlist_audio.forEach(a => {
                            // if (a.podcast_playlist_audio_listen_user_audio.status === false) {
                                audios.push({
                                    audio: a,
                                    podcast: p.id
                                })
                            // }
                        })
                    }
                    else if (p.id !== podcast.id && found && p.user_progress < 100) {
                        p.podcast_playlist_audio.forEach(a => {
                            // if (a.podcast_playlist_audio_listen_user_audio.status === false) {
                                audios.push({
                                    audio: a,
                                    podcast: p.id
                                })
                            // }
                        })
                    }
                })
            }

            this.setAudios(podcast, audios)
        },

        setAudios(podcast, audios) {
            if(this.status === 'stopped') {
                this.$store.dispatch('podcasts/SET_AUDIOS', [audios])
            }
            else {
                this.$store.dispatch('podcasts/SET_STATUS', ['stopped'])
                this.stop_podcast = podcast
                this.stopPlaying()
            }
        },

        playAudio([podcast, audio]) {
            if(this.status === 'stopped'){
                var position = ''

                let list = podcast.type == "user_podcast" ? this.user_podcasts : this.podcasts

                list.map((p, index) => { if (p.id == podcast.id)  position = index })

                let podcasts = Object.assign([], list)

                podcasts.splice(0, position)

                let audios = []

                podcasts.map(p => {
                    if(p.id == podcast.id){
                        let position_audio = ''
                        p.podcast_playlist_audio.find((a, i) => a.id == audio.id ? position_audio = i : '' )
                        p.podcast_playlist_audio.map((a, i) => {
                            if(i >= position_audio){
                                audios.push({
                                    audio: a,
                                    podcast: p.id
                                })
                            }
                        })
                    }
                    else {
                        p.podcast_playlist_audio.map(a => {
                            audios.push({
                                audio: a,
                                podcast: p.id
                            })
                        })
                    }
                })

                this.$store.dispatch('podcasts/SET_AUDIOS', [audios])
            }
            else {

                this.$store.dispatch('podcasts/SET_STATUS', ['stopped'])
                this.stop_podcast = podcast
                this.stop_audio = audio
                this.stopPlayingPlayList()

            }
        },

        changeFilter() {
            this.fetchPodcasts()
        },

        clickLike(id) {
            let obj = this.podcasts.find((obj) => { return obj.id === id })

            if (obj) {
                if (obj.liked) obj.likes--
                else if (!obj.liked) obj.likes++

                obj.liked = !obj.liked
            }

            let fd = new FormData()

            this.$axios.post(`/etraining_podcast/podcasts/${id}/set_like/`, fd, this.getHeader)
            .then(response => {
                obj.likes = response.data.likes
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        clickStars(id) {
            let obj = this.podcasts.find((obj) => { return obj.id === id })

            if (obj) {
                this.podcast = obj
                this.show_modal = true
            }
        },

        hideModal(type) {
            if (type == 'commented') {
                this.podcast.starred = true
            }
            this.show_modal = false
        },

        clickFavorite(id) {
            let obj = this.podcasts.find((obj) => { return obj.id === id })

            if (obj) {
                obj.favorited = !obj.favorited
            }

            let fd = new FormData()

            this.$axios.post(`/etraining_podcast/podcasts/${id}/set_user_favorite/`, fd, this.getHeader)
            .then(response => {
                obj.favorited = response.data.favorited
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        hideModalListPlaylist(type) {
            this.show_modal_playlist = false
        },

        clickPlaylist() {
            this.show_modal_playlist = true
        },

        fetchUserPodcast() {
            this.$q.loading.show()
            let data = {
                "page_size": 0,
                "page": this.page,
                "search": this.search,
                "favorited": this.favorite === 'all' ? false : true,
                "areas": this.selected_areas,
                "user_groups": this.selected_groups
            }

            this.$axios.get(`/etraining_podcast/playlist_user/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.user_podcasts = response.data.results.map(e => {
                    return {
                        ...e,
                        image_thumb: e.playlist_podcast_user_images.length > 0 ? e.playlist_podcast_user_images.find((obj) => { return obj.name === 'thumbnail' }).image_url : '',
                        image_large: e.playlist_podcast_user_images.length > 0 ? e.playlist_podcast_user_images.find((obj) => { return obj.name === 'large' }).image_url : '',
                        type: 'user_podcast',
                        avg_stars: 0
                    }
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        }
    },

    watch: {
        reload_content: function() {
			this.fetchAll()
			this.changeFilter()
        },

        tab: function(value) {
            if(value == 'playlist') this.fetchUserPodcast()
            if(value == 'podcast') this.fetchPodcasts()
        },
        progress_audio:{
            handler: function(progress_audio) {
                if(progress_audio.audio.status_progress == 2){
                    this.fetchPodcasts()
                }
            }, deep:true
        },
    },

    created() {
        this.fetchLists()

        this.$store.dispatch('podcasts/SET_PLAYLIST', [[]])
    },

    mounted() {
        this.stopPlaying = debounce(() => {
            this.playPlaylist(this.stop_podcast)
        }, 500)

        this.stopPlayingPlayList = debounce(() => {
            this.playAudio([this.stop_podcast, this.stop_audio])
        }, 500)
    }
}
</script>

<style>

</style>